import { Box, Container, Divider, Typography } from "@mui/material";
import { Moment } from "moment";

import AbatimentosInternacional from "./abatimentosInternacional";
import TabelaCustodiaInternacional from "./tabelaCustodiaInternacional";
import UploadStatements from "../../arquivo/abaStatements/uploadStatements";
import ListaStatements from "../../arquivo/abaStatements/listaStatements";

type Props = {
  dataBase: Moment;
};

export default function CadastrarPontoDePartidaInternacional({
  dataBase,
}: Props) {
  return (
    <Container maxWidth="lg">
      <Box
        display="flex"
        flexDirection="column"
        style={{ width: "100%" }}
        paddingBottom={8}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box flexGrow={1}>
            <Typography
              variant="eyebrow"
              color="text.secondary"
              sx={{ display: "block", pt: 2 }}
            >
              Lei 14.754/2023
            </Typography>
            <Typography
              variant="h2"
              color="text.primary"
              gutterBottom
              sx={{ pt: 1, pb: 1 }}
            >
              Ponto de partida - Internacional
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Se tiver iniciado suas operacoes internacionais antes de{" "}
              <Typography
                component="span"
                variant="dataMono"
                sx={{ fontSize: "inherit" }}
              >
                {dataBase
                  .clone()
                  .tz("America/Sao_Paulo")
                  .add(1, "day")
                  .format("DD/MM/YYYY")}
              </Typography>
              , preencha a sua custodia inicial e prejuizos acumulados em{" "}
              <Typography
                component="span"
                variant="dataMono"
                sx={{ fontSize: "inherit" }}
              >
                {dataBase.clone().tz("America/Sao_Paulo").format("DD/MM/YYYY")}
              </Typography>
              .
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ fontStyle: "italic" }}
            >
              Apos preencher as informacoes, clique em "Salvar" e recalcule seus
              meses.
            </Typography>
          </Box>
        </Box>
        <AbatimentosInternacional dataBase={dataBase} />
        <TabelaCustodiaInternacional data={dataBase} />

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography variant="h3" color="text.primary" sx={{ mb: 2 }}>
            Importar Statements
          </Typography>
          <UploadStatements />
          <Box sx={{ mt: 2 }}>
            <ListaStatements />
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
